import { graphql } from 'react-relay/legacy';

export const shoppingWithRoot = graphql`
    query shoppingWithRootQuery(
        $urlLabel: String
        $previewId: String
        $isTrade: Boolean!
        $userCountryCode: String
    ) {
        viewer {
            ...ShoppingWithWrapper_viewer
            shoppingWith(urlLabel: $urlLabel, previewId: $previewId) {
                title
                mainImage
                translationStatus
                items {
                    metaContentImage: firstPhotoWebPath(size: small)
                }
                ...ShoppingWithWrapper_shoppingWith
            }
        }
    }
`;
